module.exports = __webpack_public_path__ + "static/media/add_property.5727c440.png";